// performance.js - Performance measurement utilities for router guards

const measurements = new Map()

/**
 * Start measuring router guard performance
 * @param {string} routeName - Name of the route being navigated to
 * @returns {string} - Measurement ID
 */
export function measureRouterGuard(routeName) {
  const id = `guard_${routeName}_${Date.now()}`

  measurements.set(id, {
    routeName,
    startTime: performance.now(),
  })

  return id
}

/**
 * End measurement and optionally log the result
 * @param {string} id - Measurement ID returned from measureRouterGuard
 * @param {object} metadata - Additional metadata to log
 */
export function endMeasurement(id, metadata = {}) {
  const measurement = measurements.get(id)
  if (!measurement) {
    console.warn(`[performance] No measurement found for ${id}`)

    return
  }

  const duration = performance.now() - measurement.startTime

  if (import.meta.env.DEV && import.meta.env.VITE_APP_DEBUG_PERF === 'true') {
    console.debug(`[performance] Router guard ${measurement.routeName}:`, {
      duration: `${duration.toFixed(2)}ms`,
      ...metadata,
    })
  }

  measurements.delete(id)
}
